/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 12:09:10
 * @FilePath: \eu-eswop-official-site\src\router\index.js
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { vm } from '@/locales'
import Home from '../views/home/index.vue'
import error from '../views/404/index.vue'
import WhoAreWe from '../views/home/whoAreWe.vue'
import Business from '../views/home/business.vue'
import PrivacyPolicy from '../views/privacyPolicy/index.vue'
import TermsAndConditions from '../views/termsAndConditions/index.vue'
import FAQs from '../views/FAQs/index.vue'
import inspectionPhotograph from '../views/upload/inspectionPhotograph.vue'
import inspectionPhotographSuccess from '../views/upload/inspectionPhotographSuccess'
import inspectionPhotographfail from '../views/upload/inspectionPhotographfail.vue'
import shippingLable from '../views/shippingLable/shippingLable.vue'
import order from '../views/order/order.vue'
import Product from '../views/product/productContainer.vue'
import Search from '../views/search/searchContainer.vue'
import Property from '../views/property/propertyContainer.vue'
import Evaluate from '../views/evaluate/evaluateContainer.vue'
import SettleAccount from '../views/settleAccount/settleAccountContainer.vue'
import SuccessOrder from '../views/successOrder/successOrder.vue'
import Protocol from '../views/protocol/protocolContainer.vue'
import blog from '../views/blog/index.vue'
import blogDetail from '../views/blog/blogDetail.vue'
import cookiePriva from '../views/cookiePriva/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  }, 
  {
    path: '/error',
    name: 'error',
    component: error
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    // redirect: '/error'
  },
  {
    path: '/home/whoAreWe',
    name: 'WhoAreWe',
    component: WhoAreWe
  },
  {
    path: '/home/business',
    name: 'Business',
    component: Business
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/termsAndConditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/cookiePriva',
    name: 'cookiePriva',
    component: cookiePriva
  }, 
  {
    path: '/FAQs',
    name: 'FAQs',
    component: FAQs
  },
  {
    path: '/product',
    name: 'Product',
    meta: { title: vm.$t("router.selectModel") }, // 选择机型
    component: Product
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/blogList',
    name: 'blogList',
    component: blog
  },
  {
    path: '/blogDetail',
    name: 'BlogDetail',
    component: blogDetail
  },
  {
    path: '/property',
    name: 'Property',
    meta: { title: vm.$t("router.selectProperty") }, // 选择估价信息
    component: Property
  },
  {
    path: '/evaluate',
    name: 'Evaluate',
    meta: { title: vm.$t("router.price") }, // 预估价
    component: Evaluate
  },
  {
    path: '/settleAccount',
    name: 'SettleAccount',
    meta: { title: vm.$t("router.priceOrder") }, // 预估价2 信息填写
    component: SettleAccount
  },
  {
    path: '/successOrder',
    name: 'SuccessOrder',
    meta: { title: vm.$t("router.orderSuccess") }, 
    component: SuccessOrder
  },
  {
    path: '/protocol',
    name: 'Protocol',
    meta: { title: 'Details' },
    component: Protocol
  },
  {
    path: '/inspectionPhotograph',
    name: 'inspectionPhotograph',
    component: inspectionPhotograph,
    meta: { qualify: true }
  },
  {
    path: '/inspectionPhotographSuccess',
    name: 'inspectionPhotographSuccess',
    component: inspectionPhotographSuccess,
    meta: { qualify: true }
  },
  {
    path: '/inspectionPhotographfail',
    name: 'inspectionPhotographfail',
    component: inspectionPhotographfail,
    meta: { qualify: true }
  },
  {
    path: '/shippingLable',
    name: 'shippingLable',
    component: shippingLable,
    meta: { qualify: true }
  },
  {
    path: '/order',
    name: 'order',
    component: order,
    meta: { qualify: true }
  },
  // 添加通配符路由，捕获所有未匹配的路由
  {
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

// 添加路由守卫，处理导航错误
router.onError((error) => {
  console.error('路由错误:', error)
  // 如果是组件加载失败或其他导航错误，跳转到错误页面
  router.push('/error')
})

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  } else {
    return originalPush.call(this, location).catch(err => {
      // 如果push失败，跳转到错误页面
      console.error('路由跳转错误:', err)
      if (err.name !== 'NavigationDuplicated') {
        this.replace('/error')
      }
      return Promise.reject(err)
    })
  }
}

// replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  } else {
    return originalReplace.call(this, location).catch(err => {
      // 如果replace失败，跳转到错误页面
      console.error('路由替换错误:', err)
      if (err.name !== 'NavigationDuplicated') {
        this.push('/error')
      }
      return Promise.reject(err)
    })
  }
}

export default router